import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BGR_STATUS, FAILED_BGRS } from 'src/app/core/enums/background.enum';
import { Certification } from 'src/app/core/models/certification.model';
import { CertificateService } from 'src/app/core/services/certificate.service';
import { DialogService } from 'src/app/core/services/dailog.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-user-lookup',
  templateUrl: './user-lookup.component.html',
  styleUrls: ['./user-lookup.component.scss']
})
export class UserLookupComponent {

  FAILED_BGRS = FAILED_BGRS
  BGR_STATUS = BGR_STATUS
  @Output() onUserFound: EventEmitter<any> = new EventEmitter();
  @Input() alsdeUser:any = {demographics:{alsdeId:""}};
  formAlsdeId: string = "";
  searchError: string = "";
  isLoadingUser = false;
  certificates: Certification[] = [];
  isLoadingCerts = false;

  constructor(
    public userService: UserService,
    public dialogService: DialogService,
    private certService: CertificateService,
  ){}

  ngOnChanges() {
    this.formAlsdeId = this.alsdeUser?.demographics?.alsdeId;
    if (this.formAlsdeId) {
      this.loadCertificates(this.formAlsdeId);
    }
  }

  searchUser(){
    this.searchError = "";
    this.isLoadingUser = true;
    this.userService.getUserDemographics(this.formAlsdeId).subscribe({
      next:(user)=>{
        this.isLoadingUser = false;
        this.emitUser(user);
        const alsdeId = user?.demographics?.alsdeId;
        if (alsdeId) {
          this.loadCertificates(alsdeId);
        } else {
          this.certificates = [];
        }
      },
      error: (err)=>{
        this.isLoadingUser = false;
        const raw = typeof err.error === 'string' ? err.error : (err.error?.detail || err.error?.title || err.message || "An error occurred");
        // Break ' - section' lists onto their own lines for readability (paired with white-space:pre-line in the template).
        this.searchError = raw.replace(/ - /g, '\n- ');
        this.emitUser({demographics:{alsdeId:""}});
        this.certificates = [];
      }
    })
  }

  private loadCertificates(alsdeId: string) {
    this.isLoadingCerts = true;
    this.certService.getCertificatesByAlsdeId(alsdeId).subscribe({
      next: (certs: Certification[]) => {
        this.certificates = certs;
        this.isLoadingCerts = false;
      },
      error: () => {
        this.certificates = [];
        this.isLoadingCerts = false;
      }
    });
  }

  emitUser(user:any){
    this.alsdeUser = user;
    this.onUserFound.emit(this.alsdeUser);
  }

  reset(){
    this.formAlsdeId = "";
    this.certificates = [];
    if(this.alsdeUser.background){
      this.emitUser({demographics:{alsdeId:""}});
    }
  }
}
